// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1YLZu","content":"ManualTimeModal_content__1IGxX"};